module.exports = __webpack_public_path__ + "static/media/1015748.8ee74838.png";